import type { FC } from 'react';
import React from 'react';
import type { MessageDescriptor } from 'react-intl-next';
import { FormattedMessage } from 'react-intl-next';

import { DropdownItem as AkDropdownItem } from '@atlaskit/dropdown-menu';

type SortByDropdownClickItemProps = {
	msg: MessageDescriptor;
	onClick: () => void;
};

export const SortByDropdownClickItem: FC<SortByDropdownClickItemProps> = ({ msg, onClick }) => (
	<AkDropdownItem onClick={onClick}>
		<FormattedMessage {...msg} key={msg.id} />
	</AkDropdownItem>
);
